import React from 'react'
import agent from '../agent'
import { connect } from 'react-redux'
import { store } from '../store'
import { push } from 'react-router-redux'
import ListErrors from './ListErrors'
import {
  LOGIN,
  REDIRECT
} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL } from '../constants/config'
import { Link } from 'react-router-dom'
const mapStateToProps = state => ({
  ...state.auth,
  redirectTo: state.common.redirectTo,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onSubmit: (payload) =>
    dispatch({ type: LOGIN, payload }),
  onRedirect: () =>
    dispatch({ type: REDIRECT })
})

class Login extends React.Component {
  constructor() {
    super()
    this.state = {
      email: '',
      password: ''
    }
    this.updateState = field => ev => {
      const state = this.state;
      const newState = Object.assign({}, state, { [field]: ev.target.value });
      this.setState(newState);
    }
    this.submitForm = (email, password) => ev => {
      ev.preventDefault()
      const payload = agent.Auth.login(email, password)
      this.props.onSubmit(payload)
    }
  }
  componentWillMount() {
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      store.dispatch(push(nextProps.redirectTo))
      this.props.onRedirect()
    }
  }
  componentWillUnmount() {
  }

  render() {
    const email = this.state.email
    const password = this.state.password
    return (
      <div id="focus">
        <div id="main">
          <div id="main-wrap">
            <div id="focus-wrap">
              <h2>Log in</h2>
              <div className="FormItem">
                <label>Email</label>
                <input type="text" placeholder="Email" value={email} onChange={this.updateState('email')} />
              </div>
              <div className="FormItem">
                <label>Password</label>
                <input type="password" value={password} onChange={this.updateState('password')} />
              </div>
              <ListErrors errors={this.props.errors} />
              <div className="FormItem">
                <button onClick={this.submitForm(email, password)}>{this.props.inProgress ? 'Login...' : 'Login'}</button>
              </div>
              {/* <div className="FormItem">
                <Link to="/register"> <em>Register Here</em></Link>
              </div> */}
            </div>

            <div>
              <img src='/image/poweredby.png' style={{width:'65%', marginTop:'25px'}} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
